import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ENROLMENT_ROUTE_PROVIDER } from './enrolment-route.provider';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [],
})
export class EnrolmentConfigModule {
  static forRoot(): ModuleWithProviders<EnrolmentConfigModule> {
    return {
      ngModule: EnrolmentConfigModule,
      providers: [ENROLMENT_ROUTE_PROVIDER],
    };
  }
}
